/**
 * `P0-UIK-001`: joins class names, dropping the absent ones.
 *
 * Thirteen components each writing `[a, b].filter(Boolean).join(" ")` is
 * thirteen chances for one of them to emit `undefined` into a `class`
 * attribute, which renders as the literal word and quietly styles nothing.
 */
export const classes = (...parts: readonly (string | undefined | false)[]): string =>
  parts.filter((part): part is string => typeof part === "string" && part !== "").join(" ");
